import { getPasswordForJob } from '~/query'
import { getForeignAuthParam } from '~/query/api'

import type { VideoTranscodingResponseDTO, SubFileStatusDTO } from '@capture/client-api/src/orval'

import type { ServiceDict } from '../externals'
import { HostUrl, getJSON } from '../toolbox'

import { APIService } from './APIService'

export type VideoQuality = 'v-low' | 'v-high'

type VideoSubOption = VideoQuality | 'v-check'

type CheckVideoResponse = {
    result: SubFileStatusDTO
}

export class VideoService extends APIService {
    private hostUrl: HostUrl

    constructor(services: ServiceDict, authToken: string | undefined) {
        super('videoHost', services, authToken)
        const { commonParams } = this.getRequestContext()
        this.hostUrl = new HostUrl(services.videoHost, {
            ...commonParams,
            auth: authToken,
        })
    }

    private getFileUrl(jobID: JobID, videoID: VideoID, sub: VideoSubOption): string {
        const password = getPasswordForJob(jobID)
        return this.hostUrl.getPath(`/st/4/jobs/${jobID}/files_by_id/${videoID}`, {
            sub,
            ...getForeignAuthParam(password),
        })
    }

    public checkVideo(jobID: JobID, videoID: VideoID): Promise<CheckVideoResponse> {
        return getJSON<CheckVideoResponse>(this.getFileUrl(jobID, videoID, 'v-check'))
    }

    public getVideoUrl(jobID: JobID, videoID: VideoID, quality: VideoQuality): string {
        return this.getFileUrl(jobID, videoID, quality)
    }

    public async getVideoStream(jobID: JobID, fileID: FileID): Promise<string> {
        const password = getPasswordForJob(jobID)
        const response = await getJSON<VideoTranscodingResponseDTO>(
            this.hostUrl.getPath(`/st/4/jobs/${jobID}/video_url/${fileID}`, {
                ...getForeignAuthParam(password),
            }),
        )
        return response.url
    }
}
